<template>
  <div class="SVGbox" id="hicon">
    <svg
      width="12px"
      height="12px"
      viewBox="0 0 12 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g id="2019" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="/web/2_3" transform="translate(-912.000000, -413.000000)" :fill="color">
          <g id="body" transform="translate(310.000000, 25.000000)">
            <g id="Group-6">
              <g id="Group-3-Copy" transform="translate(25.000000, 320.000000)">
                <g id="Group-2">
                  <g id="Group-5" transform="translate(508.000000, 38.000000)">
                    <g id="Group-9" transform="translate(0.000000, 28.000000)">
                      <g id="user_16" transform="translate(67.000000, 0.000000)">
                        <path
                          d="M10.75,5.25 C10.75,3.730625 9.519375,2.5 8,2.5 C6.480625,2.5 5.25,3.730625 5.25,5.25 C5.25,6.769375 6.480625,8 8,8 C9.519375,8 10.75,6.769375 10.75,5.25 Z M2.5,11.9487179 L2.5,12.6633333 C2.5,13.0333641 2.79996922,13.3333333 3.17,13.3333333 L12.83,13.3333333 C13.2000308,13.3333333 13.5,13.0333641 13.5,12.6633333 L13.5,11.9487179 C13.5,9.52564103 9.835625,8.83333333 8,8.83333333 C6.164375,8.83333333 2.5,9.52564103 2.5,11.9487179 Z"
                          id="3x"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "asset-hicon",
  props: ["color"]
};
</script>

<style scoped>
#hicon {
  width: 16px;
  height: 16px;
  float: right;
  margin-top: -2px;
  margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/assets/hicon.vue